<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Modbus"}}</h4>
	</div>
</div>
<div class="row">
	<div class="col-sm-6">
		<div class="card-box bg-white js-request-card">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-12">
						<input id="js-mb-register" class="form-control" type="number" name="mb-register" placeholder="{{TR "Modbus Register Nr."}}">
					</div>
				</div>
				<div class="form-group text-center">
					<div class="col-xs-12">
						<button id="js-read-register" class="js-mb-request btn btn-default btn-block text-uppercase" type="submit">
							{{TR "Abfragen"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="card-box bg-white js-request-card">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-8">
						<input id="js-mb-register-w" class="form-control" type="number" name="mb-register-w" placeholder="{{TR "Modbus Register Nr."}}">
					</div>
					<div class="col-xs-4">
						<input id="js-mb-value-w" class="form-control" type="number" name="mb-value-w" placeholder="{{TR "Wert"}}">
					</div>
				</div>
				<div class="form-group text-center">
					<div class="col-xs-12">
						<button id="js-write-register" class="js-mb-request-w btn btn-default btn-block text-uppercase" type="submit">
							{{TR "Schreiben"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="row">
	<div class="col-sm-6">
		<div class="card-box bg-white js-request-card">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-12">
						<input id="js-mb-coil" class="form-control" type="number" name="mb-coil" placeholder="{{TR "Modbus Coil Nr."}}">
					</div>
				</div>
				<div class="form-group text-center">
					<div class="col-xs-12">
						<button id="js-read-coil" class="js-mb-request btn btn-default btn-block text-uppercase" type="submit">
							{{TR "Abfragen"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="card-box bg-white js-request-card">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-8">
						<input id="js-mb-coil-w" class="form-control" type="number" name="mb-coil-w" placeholder="{{TR "Modbus Coil Nr."}}">
					</div>
					<div class="col-xs-4">
						<input id="js-mb-coil-value-w" class="form-control" type="number" name="mb-coil-value-w" placeholder="{{TR "Wert"}}">
					</div>
				</div>
				<div class="form-group text-center">
					<div class="col-xs-12">
						<button id="js-write-coil" class="js-mb-request-w btn btn-default btn-block text-uppercase" type="submit">
							{{TR "Schreiben"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

<div class="row">
    <div class="col-sm-6">
        <div class="card-box bg-white js-request-card">
            <form class="form-horizontal" action="#" method="post">
                <div class="form-group ">
                    <div class="col-xs-12">
                        <input id="js-mb-input" class="form-control" type="number" name="mb-input" placeholder="{{TR "Modbus Input Register Nr."}}">
                    </div>
                </div>
                <div class="form-group text-center">
                    <div class="col-xs-12">
                        <button id="js-read-input" class="js-mb-request btn btn-default btn-block text-uppercase" type="submit">
                            {{TR "Abfragen"}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-6">
        <div class="card-box bg-white js-request-card">
            <form class="form-horizontal" action="#" method="post">
                <div class="form-group ">
                    <div class="col-xs-12">
                        <input id="js-mb-discrete" class="form-control" type="number" name="mb-discrete" placeholder="{{TR "Modbus Discrete Input Nr."}}">
                    </div>
                </div>
                <div class="form-group text-center">
                    <div class="col-xs-12">
                        <button id="js-read-discrete" class="js-mb-request btn btn-default btn-block text-uppercase" type="submit">
                            {{TR "Abfragen"}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!--- APN-Switch, only for GPRS-Gateways --->
{{#COMPARE type '==' '5014'}}
<div class="row">
	<div class="col-sm-6">
		<div class="card-box bg-white js-request-card">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-12">
						<input disabled id="js-mb-apn" class="form-control" type="number" name="mb-register" placeholder="{{TR "APN-Register"}}">
					</div>
				</div>
				<div class="form-group text-center">
					<div class="col-xs-12">
						<button id="js-read-apn" class="js-mb-request btn btn-default btn-block text-uppercase" type="submit">
							{{TR "Abfragen"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="card-box bg-white js-request-card">
			<form class="form-horizontal" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-12">
						<input id="js-mb-apn-value-w" class="form-control" type="text" name="mb-apn-value-w" placeholder="{{TR "Access Point Name Nr. 2"}}">
					</div>
				</div>
				<div class="form-group text-center">
					<div class="col-xs-12">
						<button id="js-write-apn" class="js-mb-request-w btn btn-default btn-block text-uppercase" type="submit">
							{{TR "Schreiben"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
{{/COMPARE}}

{{#if response}}
<div class="row">
	<div class="col-sm-12">
		<pre>{{JSON response 2}}</pre>
	</div>
</div>
{{/if}}
<div class="row">
	<div class="col-sm-6">
		{{type}} @ Station {{station}}
	</div>
</div>
